<template>
    <div class="animated fadeIn">
        <div
            class="kgr-alert kgr-alert--info kgr-alert--noIcon kgr-row"
        >
            <span class="kgr-text kgr-text--bold">
                <kgr-icon
                    icon-class="info-circle"
                    style="margin-bottom: -5px;margin-right:5px;color:black;"
                    disabled
                    small
                />{{ $t('Hinweis') }}</span><br />
            {{ $t('Nach Wahl einer Zeitspanne werden alle Rechnungsposten angezeigt und addiert, die mit ihrem Rechnungsdatum in diesen Zeitraum fallen. Die Rechnungsposten werden einer Abteilungen zugeordnet, wenn ihr Beitrag der Abteilung zugewiesen wurde (Beiträge verwalten), ansonsten werden die Rechnungsposten unter den Vereinsbeiträgen angezeigt und summiert.') }}
        </div>
        <div class="kgr-inputGroup">
            <div
                class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters"
                style="align-items: end;"
            >
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('Start')"
                        :error="error"
                        field-name="start"
                    >
                        <kgr-date-picker
                            v-model="start"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('Ende')"
                        :error="error"
                        field-name="end"
                    >
                        <kgr-date-picker
                            v-model="end"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell  kgr-text--rightAligned">
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="loadInvoiceAssets"
                    >
                        {{ $t('Anzeigen') }}
                    </button>
                    <button
                        class="kgr-button kgr-button--accent"
                        @click="download"
                    >
                        {{ $t('Excel-Download') }}
                    </button>
                </div>
            </div>
        </div>
        <hr class="kgr-separator--light" />
        <div
            v-if="excelLoadingError"
            class="kgr-alert kgr-alert--warning kgr-row"
        >
            {{ $t('Es gab einen Fehler beim Export der Daten. Bitte versuche einen kleineren Zeitraum.') }}
        </div>
        <div v-show="loading">
            <kgr-loader :loading="loading" />
        </div>
        <div v-show="!loading && !initialLoadingState">
            <div
                class="kgr-alert kgr-alert--info kgr-row"
            >
                <div
                    class="kgr-grid kgr-grid--gutters kgr-grid--bigGutters"
                >
                    <div class="kgr-grid__cell">
                        {{ $t('Einnahmen gesamt:') }}
                    </div>
                    <div class="kgr-grid__cell  kgr-text--rightAligned">
                        {{ getOverall() }} EUR
                    </div>
                </div>
            </div>
            <kgr-accordion>
                <kgr-accordion-item>
                    <template #header-left>
                        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                            {{ $t('Vereinsbeiträge') }}
                        </h3>
                        <div class="kgr-text kgr-text--extraSmall">
                            {{ $t('Grundbeiträge und Aufnahmegebühren aller Nicht-Abteilungs-Gebühren') }}
                        </div>
                    </template>
                    <template #header-right>
                        {{ getClubFeeOverall() }} EUR
                    </template>

                    <table class="kgr-table kgr-table--block kgr-table--striped printable">
                        <thead>
                            <tr class="kgr-table__row">
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Beitrag') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Kategorie') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Mitglied') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Rechnungsnummer') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Leistungszeitraum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Faktor') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Einzelpreis') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Preis') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="assets.filter(asset => asset.department.id === null).length === 0">
                                <td
                                    colspan="8"
                                    style="text-align: center;"
                                >
                                    {{ $t('dataTable.noData') }}
                                </td>
                            </tr>
                            <template v-else>
                                <tr
                                    v-for="asset in assets.filter(asset => asset.department.id === null)"
                                    :key="asset.id"
                                    class="kgr-table__row"
                                >
                                    <td class="kgr-table__cell">
                                        {{ asset.fee }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.category }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.consumer.name }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.invoiceNumber }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getServicePeriod(asset.servicePeriod) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getFactor(asset.factor) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getPrice(asset.unitPrice) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getPrice(asset.factorizedPrice) }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </kgr-accordion-item>
                <hr class="kgr-separator--light" />
                <div
                    v-if="!loading && departments.length === 0"
                    class="kgr-alert kgr-alert--info kgr-row"
                >
                    {{ $t('Es existieren derzeit keine Abteilungen.') }}
                </div>

                <kgr-accordion-item
                    v-for="department in departments"
                    :key="department.id"
                >
                    <template #header-left>
                        <h3 class="kgr-headline kgr-headline--h3 kgr-headline--text kgr-headline--firstInText">
                            {{ department.name }}
                        </h3>
                        <div class="kgr-text kgr-text--extraSmall">
                            Sonderbeiträge und Aufnahmegebühren der Abteilung "{{ department.name }}"
                        </div>
                    </template>
                    <template #header-right>
                        {{ getDepartmentOverall(department) }} EUR
                    </template>

                    <table class="kgr-table kgr-table--block kgr-table--striped printable">
                        <thead>
                            <tr class="kgr-table__row">
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Beitrag') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Kategorie') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Mitglied') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Rechnungsnummer') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Leistungszeitraum') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Faktor') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Einzelpreis') }}
                                </th>
                                <th class="kgr-table__cell kgr-table__cell--headline">
                                    {{ $t('Preis') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="assets.filter(asset => asset.department.id === department.id).length === 0">
                                <td
                                    colspan="8"
                                    style="text-align: center;"
                                >
                                    {{ $t('dataTable.noData') }}
                                </td>
                            </tr>
                            <template v-else>
                                <tr
                                    v-for="asset in assets.filter(asset => asset.department.id === department.id)"
                                    :key="asset.id"
                                    class="kgr-table__row"
                                >
                                    <td class="kgr-table__cell">
                                        {{ asset.fee }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.category }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.consumer.name }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ asset.invoiceNumber }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getServicePeriod(asset.servicePeriod) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getFactor(asset.factor) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getPrice(asset.unitPrice) }}
                                    </td>
                                    <td class="kgr-table__cell">
                                        {{ getPrice(asset.factorizedPrice) }}
                                    </td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </kgr-accordion-item>
            </kgr-accordion>
        </div>
    </div>
</template>

<script>
import { endOfMonth, format, parse, startOfMonth } from '@legacy/js/date/date-fns.js';
import Accordion from '../../../components/common/accordion/Accordion.vue';
import AccordionItem from '../../../components/common/accordion/AccordionItem.vue';
import ClubInvoiceAsset from '../../../js/dto/ClubInvoiceAsset.js';
import ClubInvoiceAssetRepository from '../../../js/repository/ClubInvoiceAssetRepository.js';
import DatePicker from '../../../components/common/form/picker/DatePicker.vue';
import Error from '../../../js/model/Error.js';
import FormRow from '../../../components/common/form/FormRow.vue';
import Helper from '../../../js/accounting/Helper.js';
import Icon from '../../../components/common/icon/Icon.vue';
import Loading from '../../../components/common/Loading.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-form-row': FormRow,
        'kgr-loader': Loading,
        'kgr-icon': Icon,
        'kgr-accordion': Accordion,
        'kgr-accordion-item': AccordionItem,
        'kgr-date-picker': DatePicker,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            error: new Error(),
            loading: false,
            start: format(startOfMonth(new Date()), 'dd.MM.yyyy'),
            end: format(endOfMonth(new Date()), 'dd.MM.yyyy'),
            headers: [
                { text: 'Beitrag', value: 'fee' },
                { text: 'Kategorie', value: 'category' },
                { text: 'Mitglied', value: 'consumer', sortable: false },
                { text: 'Rechnungsnummer', value: 'invoiceNumber', sortable: false },
                { text: 'Leistungszeitraum', value: 'servicePeriod', sortable: false },
                { text: 'Faktor', value: 'factor', sortable: false },
                { text: 'Einzelpreis', value: 'unitPrice', sortable: false },
                { text: 'Preis', value: 'factorizedPrice', sortable: false },
            ],
            departments: [],
            assets: [],
            loadingError: false,
            excelLoadingError: false,
            initialLoadingState: true,
        };
    },
    created() {
        this.loadDepartments();
    },
    methods: {
        loadDepartments() {
            axios
                .get(`/club/clubs/${this.clubId}/departments`)
                .then((response) => this.departments = response.data.data);
        },
        loadInvoiceAssets() {
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const formattedStart = format(start, 'yyyy-MM-dd');
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            const formattedEnd = format(end, 'yyyy-MM-dd');

            if (formattedEnd < formattedStart) {
                return;
            }
            this.initialLoadingState = false;
            this.loading = true;
            this.loadingError = false;
            axios
                .get(`/club/clubs/${this.clubId}/club-invoice-assets?servicePeriod=${formattedStart}:${formattedEnd}`)
                .then((response) => {
                    this.assets = response.data.data.map((asset) => ClubInvoiceAsset.fromData(asset));
                })
                .catch(() => {
                    this.loadingError = true;
                })
                .finally(() => this.loading = false);
        },
        getServicePeriod(servicePeriod) {
            return `${new Helper().formatDate(servicePeriod.start)} - ${new Helper().formatDate(servicePeriod.end)}`;
        },
        getFactor(factor) {
            return (factor.numerator / factor.denominator).toFixed(2);
        },
        getPrice(price) {
            return new Helper().getPrice(price);
        },
        getClubFeeOverall() {
            return this.assets
                .filter((asset) => asset.department.id === null)
                .map((asset) => asset.factorizedPrice.gross.numerator / asset.factorizedPrice.gross.denominator)
                .reduce((accumulator, price) => accumulator + price, 0)
                .toFixed(2)
            ;
        },
        getDepartmentOverall(department) {
            return this.assets
                .filter((asset) => asset.department.id === department.id)
                .map((asset) => asset.factorizedPrice.gross.numerator / asset.factorizedPrice.gross.denominator)
                .reduce((accumulator, price) => accumulator + price, 0)
                .toFixed(2)
            ;
        },
        getOverall() {
            return this.assets
                .map((asset) => asset.factorizedPrice.gross.numerator / asset.factorizedPrice.gross.denominator)
                .reduce((accumulator, price) => accumulator + price, 0)
                .toFixed(2)
            ;
        },
        download() {
            const start = parse(this.start, 'dd.MM.yyyy', new Date());
            const formattedStart = format(start, 'yyyy-MM-dd');
            const end = parse(this.end, 'dd.MM.yyyy', new Date());
            const formattedEnd = format(end, 'yyyy-MM-dd');

            if (formattedEnd < formattedStart) {
                return;
            }
            this.excelLoadingError = false;
            ClubInvoiceAssetRepository.downloadXlsx(this.clubId, formattedStart, formattedEnd)
                .catch(() => {
                    this.excelLoadingError = true;
                });
        },
    },
};
</script>
